module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "new_alert_header.4113bee8.svg";